import { render } from "./WizardResultsSuggestion.vue?vue&type=template&id=504e38e4"
import script from "./WizardResultsSuggestion.vue?vue&type=script&lang=js"
export * from "./WizardResultsSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardResultsSuggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "504e38e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('504e38e4', __exports__)) {
    api.reload('504e38e4', __exports__)
  }
  
  module.hot.accept("./WizardResultsSuggestion.vue?vue&type=template&id=504e38e4", () => {
    api.rerender('504e38e4', render)
  })

}


export default __exports__